










































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import MaterialCard from '@/components/material/Card/index.vue';
import DateRangePicker from '@/components/material/DateRangePicker/index.vue';
import { formatDate, translateComponentResource } from '@/utils/index';
import { BookingStatusEnum, IssuedStatusEnum } from '@/api/types';
import { BookingModule, BookingSearchForm } from '@/store/modules/booking';
import bookingRoutes from '@/router/paths/booking';

@Component({
  name: 'BookingSearchForm',
  components: {
    MaterialCard,
    DateRangePicker,
  },
})
export default class extends Vue {
  private readonly naiveToday = formatDate(new Date());
  private participantName = '';
  private bookingIdPrefix = '';
  private supplierId = '';
  private activityName = '';
  private planName = '';
  private purchaseDateRangeMenu = false;
  private purchaseDateRange: string[] = [];
  private participationDateMenu = false;
  private participationDateRange: string[] = [];
  private statuses: IssuedStatusEnum[] = [];
  private itemCount: number = 10;
  private page: number = 1;
  private valid = true;
  private detailedSearch = false;

  get formattedPurchaseDateRange() {
    return this.formatDateRange(this.purchaseDateRange);
  }

  get formattedParticipationDateRange() {
    return this.formatDateRange(this.participationDateRange);
  }

  get statusItems() {
    return Object.values(BookingStatusEnum).map((s: BookingStatusEnum) => ({
      text: this.$t(`BookingStatusEnum.${s}`),
      value: s,
    }));
  }

  get canSubmit() {
    return (
      this.valid &&
      (this.participantName ||
        this.bookingIdPrefix ||
        this.activityName ||
        this.planName ||
        (this.purchaseDateRange && this.purchaseDateRange.length > 0) ||
        (this.participationDateRange &&
          this.participationDateRange.length > 0) ||
        (this.statuses && this.statuses.length > 0))
    );
  }

  mounted() {
    this.loadFormModelFromStore();
  }

  submit() {
    BookingModule.SaveBookingSearchForm({
      detailedSearch: this.detailedSearch,
      participantName: this.participantName,
      bookingIdPrefix: this.bookingIdPrefix,
      supplierId: this.supplierId,
      activityName: this.activityName,
      planName: this.planName,
      purchaseDateRange: this.purchaseDateRange,
      participationDateRange: this.participationDateRange,
      statuses: this.statuses,
    } as BookingSearchForm);
    this.$router.push({
      name: 'booking-search-result',
      query: {
        participantName: this.participantName,
        bookingIdPrefix: this.bookingIdPrefix,
        supplierId: this.supplierId,
        activityName: this.activityName,
        planName: this.planName,
        purchaseDateRange: JSON.stringify(this.purchaseDateRange),
        participationDateRange: JSON.stringify(this.participationDateRange),
        statuses: JSON.stringify(this.statuses),
        itemCount: this.itemCount.toString(),
        page: this.page.toString(),
      },
    });
  }

  reset() {
    (this.$refs.form as any).reset();
    this.purchaseDateRange = [];
    this.participationDateRange = [];
  }

  private handleDetailedSearchChange(detailedSearch: boolean) {
    if (!detailedSearch) {
      const bookingIdPrefix = this.bookingIdPrefix;
      this.reset();
      this.bookingIdPrefix = bookingIdPrefix;
    }
  }

  private loadFormModelFromStore() {
    BookingModule.LoadBookingSearchForm();
    this.detailedSearch = BookingModule.searchForm.detailedSearch;
    this.participantName = BookingModule.searchForm.participantName;
    this.bookingIdPrefix = BookingModule.searchForm.bookingIdPrefix;
    this.supplierId = BookingModule.searchForm.supplierId;
    this.activityName = BookingModule.searchForm.activityName;
    this.planName = BookingModule.searchForm.planName;
    this.purchaseDateRange = BookingModule.searchForm.purchaseDateRange;
    this.participationDateRange =
      BookingModule.searchForm.participationDateRange;
    this.statuses = BookingModule.searchForm.statuses;
  }

  private translateComponentResource(resource: string) {
    return translateComponentResource(
      this.$i18n,
      this.$options.name as string,
      resource
    );
  }

  private formatDateRange(dateRange: string[]) {
    if (dateRange.length > 0) {
      let range = formatDate(new Date(dateRange[0]));
      if (dateRange.length > 1) {
        range += ' - ' + formatDate(new Date(dateRange[1]));
      }
      return range;
    }
    return '';
  }
}
